export function lockBodyScroll() {
  document.body.style.overflow = "hidden";
}
export function unlockBodyScroll() {
  document.body.style.overflow = "";
}
